import { portfolioColors } from 'utils/colors';

export const RiskProfilesListMap = {
  'Playing-It-Safe': {
    name: 'Playing-It-Safe',
    riskName: 'Very Conservative',
    riskGeneric: 'Low',
    equityPercent: 20,
    label: '20% Equities / 80% Bonds',
    icon: 'anchor',
    color: portfolioColors.blue,
    description:
      'Very Conservative is a capital‑preservation strategy focused on stability and income, using a predominantly fixed‑income allocation with limited equity exposure.',
  },
  Cautious: {
    name: 'Cautious',
    riskName: 'Conservative',
    riskGeneric: 'Low to Moderate',
    equityPercent: 40,
    label: '40% Equities / 60% Bonds',
    icon: 'cloud',
    color: portfolioColors.orange,
    description:
      'Conservative is a lower‑risk approach that emphasizes steady income and reduced volatility while incorporating equities to support gradual long‑term growth.',
  },
  Classic: {
    name: 'Classic',
    riskName: 'Balanced',
    riskGeneric: 'Moderate',
    equityPercent: 60,
    label: '60% Equities / 40% Bonds',
    icon: 'leaf',
    color: portfolioColors.teal,
    description:
      'Balanced is a diversified strategy that balances growth and stability by blending meaningful equity exposure with a solid fixed‑income allocation.',
  },
  Adventurous: {
    name: 'Adventurous',
    riskName: 'Growth',
    riskGeneric: 'Moderate to High',
    equityPercent: 80,
    label: '80% Equities / 20% Bonds',
    icon: 'map signs',
    color: portfolioColors.lightBlue,
    description:
      'Growth prioritizes long‑term capital appreciation through substantial equity exposure, supported by a small allocation to fixed income for modest diversification.',
  },
  'All-In': {
    name: 'All-In',
    riskName: 'Aggressive Growth',
    riskGeneric: 'High',
    equityPercent: 100,
    label: '100% Equities / 0% Bonds',
    icon: 'lightning',
    color: portfolioColors.red,
    description:
      'Aggressive Growth is a high‑risk, high‑potential‑return strategy fully invested in equities to maximize long‑term growth opportunities.',
  },
};
